<template>
  <div id="contenedor-editar-evento-licitacion">
    <v-form v-model="formularioValido" ref="editarEventoLicitacion">
      <v-card>
        <v-card-title class="secondary--text">
          Editar Evento de Licitacion
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-select
            v-model="evento.evento"
            label="Evento de Licitacion"
            :items="itemsEventos"
            item-text="nombre"
            item-value="value"
            :rules="[mixReglas.requerido]"
            required>
          </custom-select>
          <v-row>
            <custom-date-picker
              :cols="!$vuetify.breakpoint.mobile ? '6' : '12'"
              v-model="fecha"
              label="Fecha"
              :rules="[mixReglas.requerido]"
              required>
            </custom-date-picker>
            <custom-autocomplete
              :cols="!$vuetify.breakpoint.mobile ? '6' : '12'"
              v-model="hora"
              label="Hora"
              :items="itemsHoras"
              :rules="[mixReglas.requerido]"
              required>
            </custom-autocomplete>
          </v-row>
          <custom-text-area
            v-model="evento.lugar"
            label="Lugar"
            :rules="[mixReglas.requerido]"
            required>
          </custom-text-area>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="mixActualizarEvento"
            tipo="formAceptar"
            label="Actualizar"
            :disabled="!formularioValido || enviandoFormulario"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixLicitacionEventos from './mixLicitacionEventos';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EditarEventoLicitacion',
  mixins: [mixLicitacionEventos],
  props: {
    eventoLicitacionEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextArea,
    CustomAutocomplete,
    CustomDatePicker,
    CustomSelect,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      hora: this.horaFormatoHrs(this.eventoLicitacionEditar.fechaHora),
      fecha: this.eventoLicitacionEditar.fechaHora.substring(0, 10),
      itemsEventos: [
        { nombre: 'Visita a la obra', value: 1 },
        { nombre: 'Junta de aclaraciones', value: 2 },
        { nombre: 'Apertura', value: 3 },
        { nombre: 'Fallo', value: 4 },
      ],
      itemsHoras: [
        '00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30',
        '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
        '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
        '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30',
      ],
      evento: {
        idLicitacion: this.eventoLicitacionEditar.idLicitacion,
        evento: this.eventoLicitacionEditar.evento,
        fechaHora: '',
        lugar: this.eventoLicitacionEditar.lugar,
      },

    };
  },
  methods: {
    setFechaHora() {
      if (!this.fecha || !this.hora) return;
      this.evento.fechaHora = `${this.fecha} ${this.hora}:00`;
    },
    horaFormatoHrs(fechaHora) {
      const fecha = new Date(fechaHora);
      const horas = fecha.getHours().toString().length === 1 ? `0${fecha.getHours()}` : fecha.getHours();
      const minutos = fecha.getMinutes().toString().length === 1 ? `0${fecha.getMinutes()}` : fecha.getMinutes();
      return `${horas}:${minutos}`;
    },
    limpiarFormulario() {
      this.$refs.editarEventoLicitacion.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  computed: {
    getFecha() {
      return this.fecha;
    },
    getHora() {
      return this.hora;
    },
  },
  watch: {
    getFecha() {
      this.setFechaHora();
    },
    getHora() {
      this.setFechaHora();
    },
  },

};
</script>

<style>

</style>
